// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1hgxl","description":"PatientConsentPreview_description__33qlP"};